import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="returnDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="returnSalary" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="returnPosition" upload={upload} inExtWindow={inExtWindow}/>

        </>
    );


}


export default DataForm;